import get from 'lodash.get';

const getBillingProfiles = (rootState) => get(rootState, 'products.billingProfiles', []);

export default getBillingProfiles;
